import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Snackbar,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import Appbar from "../../components/Appbar";
// import DrawerUI from '../../components/Drawer'
import Body from "../../layout/Body";
import { getPublisherAction } from "../../redux/toolkit/publisher/getPublisher";
import { useStyles } from "../../theme/theme";
import BlockUnblockPublisherDailog from "./BlockUnblockPublisherDailog";
import NoOfPublisher from "./NoOfPublisher";
import VerfiedPublisherDailog from "./VerfiedPublisherDailog";
import ManagerDetails from "./managerDetails";
import PublisherDetails from "./PublisherDetails";
import {
  createSearchParams,
  Link as LinkRRD,
  useNavigate,
} from "react-router-dom";
import ArrowRightAltSharpIcon from "@mui/icons-material/ArrowRightAltSharp";
import Alert from "@mui/material/Alert";
import RaisePaymentRequest from "./RaisePaymentRequest";
import { render } from "@testing-library/react";
import PubAmountByAdmin from "./PubAmountByAdmin";
import moment from "moment";
import PubisherVoucherStore from "./PubisherVoucherStore";
import { set } from "lodash";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/publisher"
      >
        Publisher
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Publisher
    </Typography>
  </Stack>
);

export default function Publisher() {
  // state
  const dispatch = useDispatch();
  const getPublisherSelector = useSelector((state) => state.getPublisher);
  const { data, total, loading } = getPublisherSelector;

  const classes = useStyles();
  const [blockUnblockAdmin, setBlockUnblockAdmin] = useState(false);
  const [blockAdmin, setBlockAdmin] = useState(false);
  const [verfyAdmin, setVerifyAdmin] = useState(false);
  const [publisher_id, setpublisher_id] = useState("");
  const [manager, setManager] = useState(false);
  const [publisherDetails, setPubliserDetails] = useState({});
  const [state, setState] = useState(false);
  const [detailId, setDetailId] = useState();

  const [raiseRequest, setRaiseRequest] = useState(false);
  const [OpenDialog, setOpenDialog] = useState(false);
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  // const [storeDialogOpen , setStoreDialogOpen] = useState(false);
  // const [storeData , setStoreData] = useState({});

  const RaiseRequestButton = ({ id }) => {
    // You can use hooks here if needed
    return (
      <Button
        variant="outlined"
        onClick={() => {
          setpublisher_id(id);
          setRaiseRequest(true);
        }}
      >
        Raise Request
      </Button>
    );
  };

  const qnsDataGridColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (index) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + index?.api?.getRowIndex(index.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      // renderCell: (params) => {
      //     return (
      //         <LinkRRD to={`/publisher-detail?${params?.row?._id}`}>
      //             <Typography color='primary'>{params?.row?._id}</Typography>
      //         </LinkRRD>
      //     )
      // },
    },
    {
      field: "name",
      headerName: "Publisher Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "email",
      headerName: "Publisher Email",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "total_earned_amount",
      headerName: "Total Earned Amount",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {params?.row?.total_earned_amount
              ? Number(params?.row?.total_earned_amount).toFixed(4)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "available_earned_amount",
      headerName: "Available Amount",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {params?.row?.available_earned_amount
              ? Number(params?.row?.available_earned_amount).toFixed(4)
              : 0}
          </Typography>
        );
      },
    },
    {
      field: "profileImg",
      headerName: "profile Image",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return params?.row?.profile_img ? (
          <Avatar src={params?.row?.profile_img}></Avatar>
        ) : (
          <Avatar sx={{ fontSize: 10, bgcolor: "primary.main" }}>NO Dp</Avatar>
        );
      },
    },

    {
      field: "amount_by_admin",
      headerName: "Amount By Admin",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Button
            variant=""
            color="secondary"
            onClick={() => {
              // setBlockUser(true);
              setpublisher_id(params?.row?._id);
              // console.log("Clicked row ID:", params.row._id);
              setOpenDialog(true);
            }}
            sx={{
              backgroundColor: "#2c79e6",
              color: "white",
              "&:hover": { backgroundColor: "#79a7e8" },
            }}
          >
            Amount By Admin
          </Button>
        );
      },
    },

    //  {
    //   field: "Add Store",
    //   headerName: "Add Store",
    //   flex: 1,
    //   minWidth: 200,
    //   headerClassName: "super-app-theme--header",
    //   sortable: false,
    //   filterable: false,
    //   renderCell: (params) => {
    //     return (
    //       <Button
    //         variant=""
    //         color="secondary"
    //         onClick={() => {
    //           // setBlockUser(true);
    //           setpublisher_id(params?.row?._id);
    //           setStoreData(params?.row?.store);
    //           // console.log("Clicked row ID:", params.row._id);
    //           setStoreDialogOpen(true);

    //         }}
    //         sx={{
    //           backgroundColor: "#2c79e6",
    //           color: "white",
    //           "&:hover": { backgroundColor: "#79a7e8" },
    //         }}
    //       >
    //         Store
    //       </Button>
    //     );
    //   },
    // },

    {
      field: "--",
      headerName: "Get Details",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <LinkRRD to={`/publisher-revenue-details?publisher_id=${params?.row?._id}`}>
            <Typography color="primary"> Get Details</Typography>
          </LinkRRD>
        );
      },
    },

    {
      // field: 'postback_url',
      headerName: "Manager Detail",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Button
            variant="outlined"
            onClick={() => {
              setManager(true);
              setpublisher_id(params?.row?._id);
              setPubliserDetails(params?.row);
            }}
          >
            {params?.row?.m_name ? params?.row?.m_name : "Add Manager"}
          </Button>
        );
      },
    },

     {
      field: "publisher-user",
      headerName: "Get Publisher User",
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <LinkRRD to={`/publisher-user-info?${params?.row?._id}`}>
            <Typography color="primary"> Get Publisher User</Typography>
          </LinkRRD>
        );
      },
    },
    {
      field: "block",
      headerName: "Block / Unblock Publisher",
      renderCell: (params) => {
        return (
          <>
            {params?.row?.is_block ? (
              <IconButton
                sx={{ borderRadius: 2 }}
                onClick={() => {
                  setBlockUnblockAdmin(true);
                  setBlockAdmin(false);
                  setpublisher_id(params?.row?._id);
                }}
              >
                <Typography color="primary">Unblock</Typography>
              </IconButton>
            ) : (
              <IconButton
                sx={{ borderRadius: 2 }}
                onClick={() => {
                  setBlockUnblockAdmin(true);
                  setBlockAdmin(true);
                  setpublisher_id(params?.row?._id);
                }}
              >
                <Typography color="error">Block</Typography>
              </IconButton>
            )}
          </>
        );
      },
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "Linked App",
      headerName: "Publisher Linked App",
      renderCell: (params) => {
        return (
          <>
            {/* <IconButton  sx={{ borderRadius: 2 }} onClick={() => {  }}>Linked App</IconButton> */}
            <LinkRRD to={`/publisher-linked-app?${params?.row?._id}`}>
              {/* <Typography color='primary'>{params?.row?._id}</Typography> */}
              <IconButton sx={{ borderRadius: 2 }}>
                <ArrowRightAltSharpIcon></ArrowRightAltSharpIcon>
              </IconButton>
            </LinkRRD>
          </>
        );
      },
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "verify",
      headerName: "Verify Publisher",
      renderCell: (params) => {
        const hasManagerData =
          params?.row?.m_email &&
          params?.row?.m_image &&
          params?.row?.m_mobile &&
          params?.row?.m_name;

        return (
          <>
            {params?.row?.is_verified ? (
              <Typography color="primary">Verified</Typography>
            ) : (
              <IconButton
                sx={{ borderRadius: 2 }}
                onClick={() => {
                  if (hasManagerData) {
                    setVerifyAdmin(true);
                    setpublisher_id(params?.row?._id);
                  } else {
                    alert("Please Add  Manager Details  before verifying.");
                    // <Alert severity="error">This is an error Alert.</Alert>
                  }
                }}
              >
                <Typography color="error">Verify</Typography>
              </IconButton>
            )}
          </>
        );
      },
      flex: 1,
      minWidth: 200,
      headerClassName: "super-app-theme--header",
    },
     {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{moment(params?.row?.created_at).format("lll")}</Typography>
        );
      }
    },
  ];

  // use effect
  useEffect(() => {
    dispatch(
      getPublisherAction({ page: pageState.page, limit: pageState.pageSize })
    );
  }, [dispatch, pageState.page, pageState.pageSize]);

  return (
    <>
      <Helmet>
        <title> Real Opinion Admin | Publisher </title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      {/* <DrawerUI /> */}
      <Body>
        <Box>
          <Box sx={{ my: 2 }}>
            <Typography variant="h6">Publisher Info</Typography>
            <Typography variant="subtitle2">
              Publisher related data here.
            </Typography>
          </Box>
          <Grid container sx={{ my: 3 }} spacing={2}>
            <Grid item xs={4}>
              <NoOfPublisher />
            </Grid>
          </Grid>
        </Box>

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              autoHeight
              rows={data}
              columns={qnsDataGridColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowCount={total}
              rowsPerPageOptions={[ 25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              onCellClick={(params) => {
                setpublisher_id(params?.row?._id);
              }}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>
      </Body>

      {blockUnblockAdmin && (
        <BlockUnblockPublisherDailog
          blockAdmin={blockAdmin}
          publisher_id={publisher_id}
          state={blockUnblockAdmin}
          setState={setBlockUnblockAdmin}
        />
      )}
      {verfyAdmin && (
        <VerfiedPublisherDailog
          publisher_id={publisher_id}
          state={verfyAdmin}
          setState={setVerifyAdmin}
        />
      )}
      {manager && (
        <ManagerDetails
          publisherDetails={publisherDetails}
          publisher_id={publisher_id}
          state={manager}
          setState={setManager}
        />
      )}
      {state && (
        <PublisherDetails
          state={state}
          setState={setState}
          detailId={detailId}
        />
      )}

      {raiseRequest && (
        <RaisePaymentRequest
          state={raiseRequest}
          setState={setRaiseRequest}
          publisher_id={publisher_id}
        />
      )}

      {OpenDialog && (
        <PubAmountByAdmin
          state={OpenDialog}
          setState={setOpenDialog}
          publisherId={publisher_id}
        />
      )}

       {/* {storeDialogOpen && (
        <PubisherVoucherStore
          state={storeDialogOpen}
          setState={setStoreDialogOpen}
          publisherId={publisher_id}
          storeData = {storeData}
        />
      )} */}
    </>
  );
}
